if (!customElements.get("el-ingredient-accordion")) {
  class ElIngredientAccordion extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      if (this.dataset.ready === "true") return;

      this.dataset.ready = "true";
      this.addEventListener("click", this.handleClick);
    }

    handleClick(event) {
      const trigger = event.target.closest("[data-accordion-trigger]");

      if (!trigger || !this.contains(trigger)) return;

      const currentItem = trigger.closest("[data-accordion-item]");

      if (!currentItem) return;

      const isOpen = currentItem.classList.contains("is-open");

      this.closeAll();

      if (!isOpen) {
        this.openItem(currentItem);
      }
    }

    openItem(item) {
      const trigger = item.querySelector("[data-accordion-trigger]");

      item.classList.add("is-open");

      if (trigger) {
        trigger.setAttribute("aria-expanded", "true");
      }
    }

    closeItem(item) {
      const trigger = item.querySelector("[data-accordion-trigger]");

      item.classList.remove("is-open");

      if (trigger) {
        trigger.setAttribute("aria-expanded", "false");
      }
    }

    closeAll() {
      this.querySelectorAll("[data-accordion-item].is-open").forEach((item) => {
        this.closeItem(item);
      });
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
      this.dataset.ready = "false";
    }
  }

  customElements.define("el-ingredient-accordion", ElIngredientAccordion);
}
